import { Button } from "@/components/ui/button";

/**
 * Reusable empty-state with a minimal inline SVG illustration.
 * variant: "decisions" | "timeline" | "generic"
 */
function Illustration({ variant }) {
  const stroke = "hsl(var(--muted-foreground))";
  const accent = "hsl(var(--primary))";
  if (variant === "timeline") {
    return (
      <svg width="140" height="90" viewBox="0 0 140 90" fill="none" aria-hidden="true">
        <line x1="18" y1="45" x2="122" y2="45" stroke={stroke} strokeWidth="1.5" opacity="0.5" />
        {[26, 55, 84].map((x) => (
          <circle key={x} cx={x} cy="45" r="4.5" stroke={stroke} strokeWidth="1.5" fill="hsl(var(--card))" />
        ))}
        <circle cx="113" cy="45" r="6" fill={accent} />
        <circle cx="113" cy="45" r="11" stroke={accent} strokeWidth="1.5" opacity="0.3" />
      </svg>
    );
  }
  // decisions / generic: branching decision path
  return (
    <svg width="140" height="100" viewBox="0 0 140 100" fill="none" aria-hidden="true">
      <path d="M70 92 V60" stroke={stroke} strokeWidth="1.5" />
      <path d="M70 60 C70 44 40 46 40 30" stroke={stroke} strokeWidth="1.5" />
      <path d="M70 60 C70 44 100 46 100 30" stroke={stroke} strokeWidth="1.5" />
      <circle cx="40" cy="24" r="5.5" stroke={stroke} strokeWidth="1.5" fill="hsl(var(--card))" />
      <circle cx="100" cy="24" r="5.5" stroke={stroke} strokeWidth="1.5" fill="hsl(var(--card))" />
      <circle cx="70" cy="18" r="7" fill={accent} />
      <circle cx="70" cy="18" r="13" stroke={accent} strokeWidth="1.5" opacity="0.25" />
    </svg>
  );
}

export function EmptyState({
  variant = "generic",
  title,
  description,
  actionLabel,
  onAction,
  testId = "empty-state",
}) {
  return (
    <div
      className="flex flex-col items-center rounded-xl border border-dashed border-border bg-card/50 px-8 py-16 text-center"
      data-testid={testId}
    >
      <div className="mb-5 opacity-90">
        <Illustration variant={variant} />
      </div>
      <h3 className="font-display text-lg font-bold tracking-tight">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {actionLabel && (
        <Button
          className="mt-6 bg-primary text-primary-foreground hover:opacity-90"
          onClick={onAction}
          data-testid="empty-state-action"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
